<template>
   <div id="iUserList">
         <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('InitialConf.UsersInformation')}}</h4>
                <p class="iSetupLabel">
                    <i class="ikon med-help"></i>
                    Add users and customize their access through role and permission settings.
                </p>
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('Shared.AddUser')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddUser"
                            v-bind:Name="'btn_add_iuser'">
                        </MdButton>
                    </div>

                    <div v-bind:class="'col-sm-12 col-md-9 mb-4'">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="searchListing"
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="searchListing">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'Employee Types'"
                        v-bind:Options="EmployeeTypeList"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="employeeType"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownEmployeeType"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'Roles'"
                        v-bind:Options="RoleList"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="role"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownEmployeeRole"/>
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="ProviderList.length > 1">
                    <MdSelect
                        v-bind:Label="'Company'"
                        v-bind:Options="ProviderList"
                        v-bind:FieldDescription="'company'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="providers"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownProviders"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <div class="text-center text-md-right mt-3">
                    <button
                        type="button"
                        v-on:click="searchListing"
                        class="btn btn-primary btn-login mx-2 pull-right"												
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}            
                    </button>
                </div>
            </b-col>
        </b-row>
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>


        <MdTable 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage"              
            v-bind:pageOptions="pageOptions"
            :editIconEvent="EditUser"           
            v-bind:VisibleEditIcon="true"  
            :deleteIconEvent="RemoveUser"
            v-bind:VisibleDeleteIcon="true"             
            :onRowSelected="onRowSelected"        
            :pageChanged="pageChanged"
            :perPageFunction="PerPageFunction">                
        </MdTable>


         <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"    
            v-bind:Name="'btnUsersBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnUsersNext'"
            v-bind:ClassProp="'mx-2'"/>     
        </div>



   </div>
</template>

<script>

import EmployeeTypeService from '@/services/employeetypes.service'
import UsersService from '@/services/users.service'
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import ISetup from '@/services/isetup.service.js'
import ProviderService from '@/services/provider.service'

export default {
  name: 'IUserList',
  mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        parameter:{
            SearchCriteria:"",
            PageNumber : 0,
            PageSize:0,
        },
        fields:[
            { key: 'recId', sortable: true, label: '', class: 'text-rigth hidden' },
            { key: 'firstName', sortable: true, label: this.$t('Shared.FirstName'), class: 'text-rigth' },         
            { key: 'lastName', sortable: true, label: this.$t('Shared.LastName'), class: 'text-rigth' }, 
            { key: 'credentialsDescription', sortable: true, label: this.$t('employee.Credentials'), class: 'text-rigth' },  
            { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone'), class: 'text-rigth' },
            { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },
            { key: 'roleCode', sortable: true, label: this.$t('userHeader.Role'), class: 'text-rigth' }, 
            { key: 'employeeTypeDescription', sortable: true, label: this.$t('Shared.EmployeeType'), class: 'text-rigth' },
            { key: 'npi', sortable: true, label: this.$t('Shared.NPI'), class: 'text-rigth' }, 
            { key: 'taxonomy', sortable: true, label: this.$t('Shared.Taxonomy'), class: 'text-rigth' }, 
            { key: 'licenseNumber', sortable: true, label: this.$t('InitialConf.licenseNumber'), class: 'text-rigth' },
            { key: 'licenseState', sortable: true, label: this.$t('InitialConf.licenseState'), class: 'text-rigth' },                
        ],
        ShowMessageIsEmpty:false,
        EmployeeTypeList:[],
        employeeType:"",
        RoleList:[],
        role:"",
        ProviderList:[],
        providers:"",
        items:[],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',

    }
  },

  methods:{

    Next(){
        this.$router.push({ name:'itherapies'});
    },

    Back(){
        this.$router.push({ name:'iroles'}); 
    },
    
    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.SearchUsers();   
    },

    pageChanged(page){
        this.currentPage = page;    
        this.SearchUsers();   
    },

    EditUser(row){
        this.$router.push({ name:'iuserdetail',params: { id: row.recId} });
    },

    showReport(){

    },

    onRowSelected(){

    },

    getProviders(){    
      ProviderService.getFullProvidersNoTraining()
      .then((response) => {      
           if (response.status == "200") {
                this.ProviderList = response.data;
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    ChangeDropDownEmployeeType(item){
        this.employeeType = item ? item : null;
        this.SearchUsers();
    },
    ChangeDropDownEmployeeRole(item){
        this.role = item ? item : null;
        this.SearchUsers();
    },
    ChangeDropDownProviders(item){
        this.providers = item ? item : null;
        this.SearchUsers();
    },
    AddUser(){
         this.$router.push({ name:'iuseradd'});    
    },
    searchListing(){
        this.currentPage = 1;
        this.SearchUsers();
    },

    SearchUsers(){
        this.$emit('load', true);
        this.parameter.PageNumber = this.currentPage;           
        this.parameter.PageSize = this.perPage;
        this.parameter.EmployeeTypeCode = this.employeeType !== "" && this.employeeType !== null ? this.employeeType.code : null;
        this.parameter.RoleCode = this.role !== "" && this.role !== null ? this.role.code : null;
       // this.parameter.ProviderCode = this.providers !== "" && this.providers !== null ? this.providers.code : null;
         ISetup.getAllUsers(this.parameter)
            .then((response) => {      
               if (response.status == '200' && response.data) {              
                  this.items = response.data;

                  if(this.items.length === 0){
                    this.ShowMessageIsEmpty = true;
                  }
                  this.$emit('load', false);
               }  
               this.$emit('load', false);
         })
         .catch(error => {
            this.$emit('load', false);
           this.showResponseErrorMessage(error);
         });    
    },

    RemoveUser(row){  
      this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('InitialConf.DeleteUser'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id:'modal_delete_setupUser'
				})
        .then(value => {
          if(value){
            this.$emit('load', true);    
            ISetup.DeleteUser(row.recId)
            .then(() => {
                const index = this.items.findIndex(item => item.recId  === row.recId) // find the post index 
                if (~index) {// if the post exists in array 
                  this.items.splice(index, 1) //delete the post and refresh view
                  this.SearchUsers(); //refresh listing
                }
                this.$emit('load', false);
            })
            .catch((error) => {
                this.$emit('load', false);
                this.showResponseErrorMessage(error);
            });
          }
        })
    },

     getRols(){
        UsersService.getRols()
            .then((response) => {      
               if (response.status == '200' && response.data) {              
                  this.RoleList = response.data;
               }  
         })
         .catch(error => {     
           this.showResponseErrorMessage(error);
         });    
    },

      getEmployeeTypes() {
            const param = {
                Active: true
            }
            this.EmployeeTypeList = [];
            EmployeeTypeService.getAllEmployeeType(param)
                .then(response => {
                    if (response.status == "200" && response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            this.EmployeeTypeList.push({
                                code: element.code,
                                description: element.description
                            })
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

  },

  created(){
    this.getEmployeeTypes();
    this.getRols();
    this.getProviders();
  },

  mounted(){
    this.SearchUsers();
  }
   
};
</script>


